import React from 'react';
import {
    DiscoverEventCardProps,
    EXPERIMENT_BROWSE_CARD_MAP_DESKTOP,
} from '../../components/DiscoverEventCard';
import { useServerEnrolledStatsigExperiment } from '../../context/experiments';
import {
    BrowseCardHierarchyExperiment,
    BrowseCardHierarchyExperimentValues,
} from '../../types';

function useGetEventCardVariant() {
    const updatedHierarchyVariant =
        useServerEnrolledStatsigExperiment<BrowseCardHierarchyExperimentValues>(
            {
                name: BrowseCardHierarchyExperiment.name,
                paramName: BrowseCardHierarchyExperiment.paramName,
                defaultValue: BrowseCardHierarchyExperiment.values.control,
            },
        ).variant;

    const BrowseEventCard =
        EXPERIMENT_BROWSE_CARD_MAP_DESKTOP[updatedHierarchyVariant];

    return BrowseEventCard;
}

export const BrowseEventCardStyleSwitcher: React.FunctionComponent<
    DiscoverEventCardProps
> = (props) => {
    const BrowseEventCard = useGetEventCardVariant();

    return (
        <div
            className="discover-event-card"
            key={`discover-desktop-event-card-${props.event.id}`}
        >
            <BrowseEventCard {...props} />
        </div>
    );
};
